import { action } from 'typesafe-actions';
import { EstadoOrigemTypes, IEstadoOrigem } from './types';

export const loadRequest = () => action(EstadoOrigemTypes.LOAD_REQUEST, {});
export const loadSuccess = (data: IEstadoOrigem[]) =>
  action(EstadoOrigemTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(EstadoOrigemTypes.LOAD_FAILURE, {});
